import { Component, inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { LucideAngularModule } from 'lucide-angular';
import { Input, Output, EventEmitter } from '@angular/core';
import { UserFavouriteService } from '../../../../core/services/users/favourite.service';
import { ToastService } from '../../../../layout/toast/toast.service';
import { LanguageService } from '../../../../core/services/language/language.service';
import { getStoredAuthToken } from '../../../../core/auth/auth-token';

@Component({
  selector: 'app-kebab-favourite-component',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './kebab-favourite-component.html',
  styleUrl: './kebab-favourite-component.scss'
})
export class KebabFavouriteComponent {

  @Input() data: any;
  @Output() toggleChange = new EventEmitter<void>();

  private favouriteService = inject(UserFavouriteService);
  private toast = inject(ToastService);
  private router = inject(Router);
  private languageService = inject(LanguageService);
  private platformId = inject(PLATFORM_ID);

  addToFavourite() {
    if (isPlatformBrowser(this.platformId)) {
      const token = getStoredAuthToken();
      if (!token) {
        this.toast.warning(
          this.languageService.t('loginRequiredTitle') || 'Login Required',
          this.languageService.t('loginRequiredMessage') || 'Please log in to perform this activity.'
        );
        this.toggleChange.emit();
        this.router.navigate(['/auth'], { queryParams: { redirect: this.router.url || '/' } });
        return;
      }
    }

    const title = this.data?.title || this.data?.original_title ||
                 this.data?.original_name || this.data?.name || 'Item';

    // Emit close event immediately to close menu
    this.toggleChange.emit();

    this.favouriteService.addToFavourite(this.data).subscribe({
      next: (res: any) => {
        if (res && res.status === 'already_exists') {
          this.toast.info('Favourites', `"${title}" is already in your favourites.`);
        } else {
          this.toast.success('Added to Favourites', `"${title}" has been added to your favourites.`);
        }
      },
      error: (err) => {
        console.error('Error adding to favourites:', err);
        const msg = err?.status === 401 || err?.status === 404
          ? (this.languageService.t('loginRequiredMessage') || 'Please sign in to add favourites.')
          : (err?.error?.detail || 'Could not add to favourites. Please try again.');
        this.toast.error('Favourites', msg);
      }
    });
  }
}
